export const formatToMaxDecimals = (x: number, decimals: number) => Math.round(x * 10 ** decimals) / (10 ** decimals);

export const standardPrice = 515;
export const priceTable = [
  {
    step: 1, min: 0, max: 30, price: standardPrice,
  },
  {
    step: 2, min: 30, max: 200, price: 430,
  },
  {
    step: 3, min: 200, max: 500, price: 400,
  },
  {
    step: 4, min: 500, max: 1500, price: 350,
  },
  {
    step: 5, min: 1500, max: 5000, price: 280,
  },
  {
    step: 6, min: 5000, max: 12000, price: 210,
  },
  {
    step: 7, min: 12000, max: 15000, price: 150,
  },
  {
    step: 8, min: 15000, max: Number.MAX_SAFE_INTEGER, price: 110,
  },
];

export const takeWhile = <T>(array: Array<T>, pred: (t: T) => boolean): T[] => {
  const index = array.findIndex((e) => !pred(e));
  if (index === -1) return [...array];
  return array.slice(0, index);
};

export const calculateBreakdown = (input: number) => {
  const prevRows = takeWhile(priceTable, ({ max }) => max < input);
  const currentRow = priceTable[prevRows.length];
  const totalPrice = input !== 0
    ? prevRows.reduce((res, { price, min, max }) => res + (price * (max - min)), 0)
      + (currentRow.price * (input - currentRow.min))
    : standardPrice;

  return { totalPrice, currentStep: currentRow.step };
};

export const calculatedDiscount = (input: number, averagePrice: number) => (((standardPrice - averagePrice) / standardPrice) * 100).toFixed(0);
